import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Gift, Check, Zap, X, Shield, Video, Image as ImageIcon, PenTool, Smartphone, Music, Users } from 'lucide-react';
import { Button } from '../ui/Button';
export function CourseDetails() {
  return <div className="relative" data-id="element-1">
      {/* What is it Section */}
      <section className="py-[64px] md:py-[96px] bg-bg-secondary" data-id="element-2">
        <div className="container mx-auto px-5 max-w-[1100px]" data-id="element-3">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          ease: [0.16, 1, 0.3, 1]
        }} className="text-center mb-16" data-id="element-4">
            <h2 className="text-[32px] md:text-[48px] font-[900] text-white uppercase tracking-tight" data-id="element-5">
              ¿QUÉ ES EL SISTEMA VIDEOINMO AI?
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-[24px] mb-12 items-stretch" data-id="element-6">
            {/* Left Column */}
            <motion.div initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            ease: [0.16, 1, 0.3, 1]
          }} className="bg-bg-card border border-border-card rounded-[16px] p-[36px] h-full" data-id="element-7">
              <h3 className="text-danger font-[700] uppercase text-[12px] tracking-widest mb-6" data-id="element-8">
                ✗ LO QUE NO ES
              </h3>
              <div className="h-px w-full bg-border-subtle mb-6" data-id="element-9" />
              <div className="space-y-4" data-id="element-10">
                {['No aprenderás teoría innecesaria', 'No pasarás semanas estudiando', 'No necesitas experiencia previa', 'No es un curso técnico complicado'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-11">
                    <X className="w-5 h-5 text-danger shrink-0 mt-1" data-id="element-12" />
                    <span className="text-white text-[15px] leading-[2.2]" data-id="element-13">
                      {item}
                    </span>
                  </div>)}
              </div>
            </motion.div>

            {/* Right Column */}
            <motion.div initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1,
            ease: [0.16, 1, 0.3, 1]
          }} className="bg-bg-card border border-accent-border shadow-[0_0_30px_rgba(0,180,230,0.06)] rounded-[16px] p-[36px] h-full" data-id="element-14">
              <h3 className="text-accent font-[700] uppercase text-[12px] tracking-widest mb-6" data-id="element-15">
                ✦ LO QUE SÍ ES
              </h3>
              <div className="h-px w-full bg-border-subtle mb-6" data-id="element-16" />
              <div className="space-y-4" data-id="element-17">
                {['Proceso paso a paso aplicable hoy', 'Resultados desde la primera propiedad', 'Funciona para Casas, Deptos, Terrenos, Locales y Proyectos', 'Listo en 1 a 2 horas'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-18">
                    <Check className="w-5 h-5 text-success shrink-0 mt-1" data-id="element-19" />
                    <span className="text-white text-[15px] leading-[2.2]" data-id="element-20">
                      {item}
                    </span>
                  </div>)}
              </div>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2,
          ease: [0.16, 1, 0.3, 1]
        }} className="max-w-[600px] mx-auto bg-bg-primary border border-accent-border rounded-[16px] p-[32px] text-center" data-id="element-21">
            <div className="text-[32px] mb-4" data-id="element-22">⚡</div>
            <p className="text-white font-[700] text-[18px] mb-4" data-id="element-23">
              En 1-2 horas aprenderás el proceso completo que podrás aplicar
              inmediatamente a cualquier propiedad.
            </p>
            <p className="text-text-secondary text-[14px]" data-id="element-24">
              Casas · Departamentos · Terrenos · Locales · Proyectos
            </p>
          </motion.div>
        </div>
      </section>

      {/* Modules Section */}
      <section className="py-[64px] md:py-[96px] bg-bg-primary" data-id="element-25">
        <div className="container mx-auto px-5 max-w-[1100px]" data-id="element-26">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          ease: [0.16, 1, 0.3, 1]
        }} className="text-center mb-16" data-id="element-27">
            <h2 className="text-[32px] md:text-[48px] font-[900] mb-4 uppercase text-white" data-id="element-28">
              LO QUE APRENDERÁS DENTRO DE VIDEOINMO AI
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-[24px] mb-16" data-id="element-29">
            <div className="space-y-[24px]" data-id="element-30">
              {[{
              num: '1',
              title: 'Introducción al Método VideoInmo AI',
              desc: 'Comprende cómo los agentes inmobiliarios están utilizando Inteligencia Artificial para crear contenido más atractivo y destacar sus propiedades.'
            }, {
              num: '2',
              title: 'Creación de Videos con IA',
              desc: 'Aprende a transformar fotografías de propiedades en videos profesionales utilizando Veo.'
            }, {
              num: '3',
              title: 'Prompts de Alto Rendimiento',
              desc: 'Descubre los prompts exactos para generar videos más atractivos y obtener mejores resultados.'
            }, {
              num: '4',
              title: 'Edición Profesional con CapCut',
              desc: 'Aprende a mejorar tus videos, añadir música, textos y dejar tus creativos listos para publicar.'
            }, {
              num: '5',
              title: 'Publicación y Distribución',
              desc: 'Cómo utilizar tus videos en Facebook, Instagram, WhatsApp y portales inmobiliarios para generar más visibilidad.'
            }].map((mod, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              y: 24
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: idx * 0.1,
              duration: 0.5,
              ease: [0.16, 1, 0.3, 1]
            }} className="bg-bg-card border border-border-card rounded-[16px] p-[28px] hover:border-accent-border hover:shadow-[0_12px_40px_rgba(0,180,230,0.1)] hover:-translate-y-[4px] transition-all duration-250 flex gap-6" data-id="element-31">
                  <div className="text-[32px] font-[900] text-accent/30 leading-none mt-1" data-id="element-32">
                    0{mod.num}
                  </div>
                  <div data-id="element-33">
                    <h3 className="text-[18px] font-[700] text-white mb-2" data-id="element-34">
                      Módulo {mod.num} — {mod.title}
                    </h3>
                    <p className="text-[15px] text-text-secondary leading-[1.6]" data-id="element-35">
                      {mod.desc}
                    </p>
                  </div>
                </motion.div>)}
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2,
            ease: [0.16, 1, 0.3, 1]
          }} className="bg-bg-secondary border border-accent-border shadow-[0_0_30px_rgba(0,180,230,0.06)] rounded-[16px] p-[40px] h-fit sticky top-8" data-id="element-36">
              <h3 className="text-[24px] font-[900] text-white mb-8 uppercase" data-id="element-37">
                ¿Qué Incluye Tu Acceso?
              </h3>
              <div className="space-y-4" data-id="element-38">
                {['Más de 12 clases paso a paso', 'Acceso inmediato', 'Actualizaciones futuras', 'Comunidad privada', 'Biblioteca de prompts', 'Acceso desde cualquier dispositivo'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-39">
                    <Check className="w-6 h-6 text-success shrink-0" data-id="element-40" />
                    <span className="text-white text-[16px] font-[500]" data-id="element-41">
                      {item}
                    </span>
                  </div>)}
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-[64px] md:py-[96px] bg-bg-secondary" data-id="element-42">
        <div className="container mx-auto px-5 max-w-[1100px]" data-id="element-43">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          ease: [0.16, 1, 0.3, 1]
        }} className="text-center mb-16" data-id="element-44">
            <div className="inline-block bg-accent-glow border border-accent-border text-accent rounded-[100px] px-4 py-1.5 text-[12px] font-bold uppercase tracking-wider mb-6" data-id="element-45">
              🎁 BONOS EXCLUSIVOS
            </div>
            <h2 className="text-[32px] md:text-[48px] font-[900] mb-4 uppercase text-white" data-id="element-46">
              ADEMÁS DEL CURSO, RECIBES:
            </h2>
            <p className="text-text-secondary text-[18px] font-[500]" data-id="element-47">
              Bonos incluidos sin costo adicional
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-[24px] mb-16" data-id="element-48">
            {[{
            label: 'BONO 1',
            title: 'Prompts Listos para Usar',
            desc: 'Los prompts exactos para generar videos cinematográficos de cualquier propiedad con un solo clic.',
            value: 'S/97',
            image: 'https://cdn.magicpatterns.com/uploads/3rxVjm5ShKGpfhDR8ycUVa/ChatGPT_Image_24_jun_2026,_14_51_56.png'
          }, {
            label: 'BONO 2',
            title: 'FLOW ILIMITADO',
            desc: 'Aprende a exprimir al máximo Flow para crear decenas de videos inmobiliarios de alta calidad.',
            value: 'S/47',
            image: 'https://cdn.magicpatterns.com/uploads/1jXoco2xq3wo1akntgoYxP/ChatGPT_Image_24_jun_2026,_14_55_12.png'
          }, {
            label: 'BONO 3',
            title: 'Comunidad Privada',
            desc: 'Acceso al grupo de agentes que ya usan video IA para vender más.',
            value: 'S/197',
            image: 'https://cdn.magicpatterns.com/uploads/nGsYDnLHKYUfmnek1LAVRY/ChatGPT_Image_24_jun_2026,_14_59_13.png'
          }].map((bono, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1,
            duration: 0.5,
            ease: [0.16, 1, 0.3, 1]
          }} className="bg-bg-card border border-border-card rounded-[16px] p-[32px] hover:border-accent-border hover:shadow-[0_12px_40px_rgba(0,180,230,0.1)] hover:-translate-y-[4px] transition-all duration-250 flex flex-col items-center text-center" data-id="element-49">
                <div className="w-full aspect-square rounded-[12px] mb-6 flex items-center justify-center overflow-hidden" data-id="element-50">
                  <img src={bono.image} alt={bono.title} className="w-full h-full object-cover" data-id="element-51" />
                </div>
                <div className="text-accent text-[11px] font-[700] uppercase tracking-widest mb-2" data-id="element-52">
                  {bono.label}
                </div>
                <h3 className="font-[700] text-[16px] text-white mb-3" data-id="element-53">
                  {bono.title}
                </h3>
                <p className="text-text-secondary text-[14px] mb-6 flex-grow" data-id="element-54">
                  {bono.desc}
                </p>
                <div className="bg-accent/10 border border-accent-border text-accent rounded-[8px] px-3 py-1.5 text-[12px] font-[700]" data-id="element-55">
                  VALORADO EN {bono.value}
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3,
          ease: [0.16, 1, 0.3, 1]
        }} className="text-center" data-id="element-56">
            <p className="text-text-secondary text-[18px] mb-2" data-id="element-57">
              Valor total de bonos:{' '}
              <span className="line-through text-text-muted" data-id="element-58">S/341</span>
            </p>
            <p className="text-[32px] font-[900] text-accent uppercase drop-shadow-[0_0_12px_rgba(0,180,230,0.3)] animate-glowPulse" data-id="element-59">
              INCLUIDO GRATIS
            </p>
          </motion.div>
        </div>
      </section>

      {/* Offer & Price Section */}
      <section className="py-[64px] md:py-[96px] bg-bg-primary relative overflow-hidden" data-id="element-60">
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-full max-w-[1100px] pointer-events-none" style={{
        background: 'radial-gradient(ellipse 60% 40% at 50% 100%, rgba(0,180,230,0.06) 0%, transparent 70%)'
      }} data-id="element-61" />

        <div className="container mx-auto px-5 relative z-10 flex flex-col items-center" data-id="element-62">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          ease: [0.16, 1, 0.3, 1]
        }} className="w-full max-w-[520px] text-center" data-id="element-63">
            <div className="inline-block bg-accent-glow text-accent border border-accent-border rounded-[100px] px-4 py-1.5 text-[12px] font-bold uppercase mb-8 animate-glowPulse" data-id="element-64">
              ⚡ OFERTA DE LANZAMIENTO
            </div>

            <h2 className="text-[24px] font-[400] text-text-secondary mb-2 uppercase" data-id="element-65">
              ACCEDE AHORA POR
            </h2>
            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-66">
              <span className="text-[64px] md:text-[96px] font-[900] text-[#FFFFFF] leading-none" data-id="element-67">
                S/49.90
              </span>
              <span className="text-[28px] text-[#4B5563] line-through align-middle" data-id="element-68">
                S/89
              </span>
            </div>

            <div className="mb-8" data-id="element-69">
              <p className="text-accent text-[14px] mb-3" data-id="element-70">
                ⚡ Quedan 14 de 20 cupos disponibles
              </p>
              <div className="w-full max-w-[300px] mx-auto h-[6px] bg-border-subtle rounded-[100px] overflow-hidden relative" data-id="element-71">
                <div className="absolute top-0 left-0 h-full bg-accent w-[70%] rounded-[100px] shadow-[0_0_8px_var(--accent)]" data-id="element-72" />
              </div>
            </div>

            <div className="space-y-3 text-left mb-10 max-w-[400px] mx-auto" data-id="element-73">
              {['Acceso inmediato al curso completo', 'Bono 1 — Prompts listos para usar', 'Bono 2 — Flow Ilimitado', 'Bono 3 — Comunidad privada', 'Actualizaciones futuras incluidas', 'Pago único, acceso de por vida'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-74">
                  <Check className="w-5 h-5 text-success shrink-0" data-id="element-75" />
                  <span className="text-white text-[15px]" data-id="element-76">{item}</span>
                </div>)}
            </div>

            <Button href="https://etsdvu-71.myshopify.com/cart/43467725832281:1" fullWidth className="mb-8" data-id="element-77">
              OBTENER ACCESO POR S/49.90 →
            </Button>

            <div className="bg-bg-card border border-border-subtle rounded-[12px] p-[20px_28px] max-w-[480px] mx-auto text-center" data-id="element-78">
              <p className="text-white font-[700] mb-1" data-id="element-79">
                🛡 Garantía de 7 días
              </p>
              <p className="text-text-secondary text-[14px]" data-id="element-80">
                Si no te convence, te devolvemos tu dinero. Sin preguntas.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
}